<script>
    export default {
        data() {
            return {
                parti: {}
            }
        },

        created() {
            axios.get('/part-numbers')
                .then(({data}) => this.parti = data);
        }
    }
</script>